<div (click)="switchStatus()" class="pointer uk-flex uk-flex-middle uk-flex-center">
  <ng-container *ngIf="eyeIcon; else check">
    <ng-container *ngIf="status; else elseTemplate">
      <fa-icon [icon]="['far', 'eye-slash']"></fa-icon>
    </ng-container>

    <ng-template #elseTemplate>
      <fa-icon [icon]="['far', 'eye']"></fa-icon>
    </ng-template>
  </ng-container>

  <ng-template #check>
    <ng-container *ngIf="status; else statusFalse">
      <fa-icon class="ascending" icon="check"></fa-icon>
    </ng-container>

    <ng-template #statusFalse>
      <fa-icon class="descending" icon="times"></fa-icon>
    </ng-template>
  </ng-template>
</div>
